module.exports = __webpack_public_path__ + "static/media/soundOn_btn.65344a47.png";